<template>
  <!-- dashboard-area start -->
  <div class="dashboard-area pt-30">
    <div class="container cardspadding" >
      <div class="col-12 cardspadding">
        <div class="row justify-content-center">
          <div class="col-12 cardspadding">
            <div class="pannel-wrapper white-bg" >
              <div class="rowEspecial">
                <div class="col-sm-12 mb-5 cardspadding">
                  <a target="_blank">
                    <img
                      src="https://www.lefisc.com.br/monitoramentoncm/img/banner2.png"
                      style="width:100%"
                    />
                  </a>
                </div>
              </div>
              <pesquisa-completa />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pesquisaCompleta from "../components/pesquisa/pesquisaCompleta";
import serviceCookie from "../services/ServiceCookie";
import serviceHome from "../services/ServiceHome";
import { routes } from "../routes/index";
export default {
  components: {
    "pesquisa-completa": pesquisaCompleta
  },
  data() {
    return {
      usuario: "",
      routes: routes
    };
  },
  async beforeCreate() {
    this.usuario = await serviceCookie.getCookie("idCliente");
    if (this.usuario.length > 0) {
      //this.usuario = this.usuario.substring(3);
      this.usuario = parseInt(this.usuario);
      if (!this.usuario) this.usuario = 0;
    }

    // //let contador = await serviceHome.getContadorNCMs(this.usuario);

    // /* if (contador > 0) {
    //   this.routes.forEach(rota => {
    //     if (rota.name == "Pesquisa") rota.menu = true;
    //     if (rota.name == "Início") rota.menu = false;
    //     if (rota.name == "Monitoradas") rota.menu = true;
    //   });
    //   this.$router.push({ name: "Pesquisa" });
    // } else {
    //   this.routes.forEach(rota => {
    //     if (rota.name == "Início") rota.menu = true;
    //     if (rota.name == "Pesquisa") rota.menu = false;
    //     if (rota.name == "Monitoradas") rota.menu = false;
    //   });
    // } */
  }
};
</script>

<style scoped>

.cardspadding{
  padding:0px;
}
</style>